import { render, staticRenderFns } from "./MarketingCampaignAttributeEdit.vue?vue&type=template&id=d53bb3a8&"
import script from "./MarketingCampaignAttributeEdit.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignAttributeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports